import React, { ReactElement } from 'react';
import './pripomienkaData.scss';

interface Props {
  label: string;
  value: string|number;
}

const PripomienkaData = ({ label, value } :Props): ReactElement => (
  <div>
    <div className="row-label">
      {label}
    </div>
    <div className="row-value">
      {value}
    </div>
  </div>
);

export default PripomienkaData;
